import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import rootEpic from './ops/index.tsx';
import createStore, { APP_ID } from './state/index.tsx';
import type { State, AppProps } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { APP_ID };

// eslint-disable-next-line jira/react/no-class-components
class ServicedeskPortalIdProvider extends Component<AppProps> {
	constructor(props: AppProps) {
		super(props);
		this.store = createStore(rootEpic);
	}

	store: Store<State>;

	render() {
		const { children, projectId } = this.props;
		return (
			<AppBase id={APP_ID} store={this.store}>
				<View projectId={projectId}>{children}</View>
			</AppBase>
		);
	}
}

export default ServicedeskPortalIdProvider;
